var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:['base-form', _vm.customClass],on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')},"reset":function($event){return _vm.$emit('reset')},"keydown":_vm.handleTabKey}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }